
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/list/whistler",
      function () {
        return require("private-next-pages/list/whistler.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/list/whistler"])
      });
    }
  